import React, { useMemo } from "react";
import { useClasses } from "@api/class.api";
import { ClassAvatarGroup } from "@components/avatar/ClassAvatarGroup";
import { ClassWithChildren } from "@helpers/class";
import styles from "./AccrualClassField.module.scss";

interface AccrualClassFieldProps {
    classIds: string[];
}

export const AccrualClassField: React.FC<AccrualClassFieldProps> = ({
    classIds,
}) => {
    const { classesMap, sortedClassesIndexMap } = useClasses();

    const classes = useMemo(
        () =>
            classIds
                .map((classId) => classesMap.get(classId))
                .filter((c): c is ClassWithChildren => Boolean(c))
                .toSorted((leftClass, rightClass) => {
                    const leftIndex =
                        sortedClassesIndexMap.get(leftClass.id) ?? Infinity;
                    const rightIndex =
                        sortedClassesIndexMap.get(rightClass.id) ?? Infinity;
                    return leftIndex - rightIndex;
                }),
        [classIds, classesMap, sortedClassesIndexMap],
    );

    if (classes.length === 0) {
        return <span className={styles.emptyClass}>-</span>;
    }

    return <ClassAvatarGroup classes={classes} max={3} />;
};
